var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeartRatenew(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 5,
    fill: "#F7FFF4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5807_28226)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.5 16C32.538 16 35 18.5 35 22C35 29 27.5 33 25 34.5C23.023 33.314 17.917 30.563 15.869 26.001L14 26V24H15.21C15.074 23.364 15 22.698 15 22C15 18.5 17.5 16 20.5 16C22.36 16 24 17 25 18C26 17 27.64 16 29.5 16ZM29.5 18C28.424 18 27.26 18.57 26.414 19.414L25 20.828L23.586 19.414C22.74 18.57 21.576 18 20.5 18C18.56 18 17 19.656 17 22C17 22.685 17.09 23.352 17.267 24H19.434L21.5 20.556L24.5 25.556L25.434 24H30V26H26.566L24.5 29.444L21.5 24.444L20.566 26H18.108C18.898 27.374 20.093 28.668 21.645 29.903C22.39 30.495 23.185 31.048 24.066 31.603C24.365 31.792 24.661 31.973 25 32.175C25.339 31.973 25.635 31.792 25.934 31.604C26.815 31.048 27.61 30.495 28.354 29.903C31.335 27.533 33 24.943 33 22C33 19.64 31.463 18 29.5 18Z",
    fill: "#00A651"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5807_28226"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(13 13)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartRatenew);
export default __webpack_public_path__ + "static/media/HeartRatenew.7631d2ee637d0497030ad6c824d0f37f.svg";
export { ForwardRef as ReactComponent };